"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dashboardDisrupterVisibilityValidator = void 0;
const sulu_1 = require("../../api/sulu");
const string_1 = require("../../common/js/helper/string");
const ProductType_1 = __importDefault(require("../enums/ProductType"));
const LicenseStore_1 = __importDefault(require("../stores/LicenseStore"));
const dashboardDisrupterVisibilityValidator = (disrupter) => {
    switch (disrupter.visibilityCondition) {
        case sulu_1.DisrupterItemVisibilityConditionEnum.Always:
            return true;
        case sulu_1.DisrupterItemVisibilityConditionEnum.NoZundConnectLicence:
            return 0 === calculateNumberOfZundConnectLicences();
        default:
            throw new Error(`Invalid visibility condition "${disrupter.visibilityCondition}"`);
    }
};
exports.dashboardDisrupterVisibilityValidator = dashboardDisrupterVisibilityValidator;
const calculateNumberOfZundConnectLicences = () => {
    if (LicenseStore_1.default.isLoading) {
        return -1;
    }
    return Array.from(LicenseStore_1.default.licenses.values()).filter((license) => {
        return (0, string_1.slugifyKey)(license.productType) === ProductType_1.default.ZUND_CONNECT;
    }).length;
};
